import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';

export const StContainer = styled(Grid)(() => ({
  flexDirection: 'row',
  alignItems: 'left',
  justifyContent: 'center',
  paddingTop: '1rem',
}));
